var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"realName",on:{"click":_vm.clickUserName}},[_vm._v("当前用户："+_vm._s(_vm.realName))]),_c('div',{staticClass:"logout",on:{"click":_vm.logout}},[_vm._v("退出")])])}
var staticRenderFns = []

export { render, staticRenderFns }